// Packages
import { useContext, useEffect, useState } from "react";
// import debounce from "lodash.debounce";

// Context
import { Language } from "../../Language/Language";

// Elements
import {
  ModalContainer,
  Cross,
  Card,
  CardBody,
  Title,
  Address,
  Detail,
  MapLink,
  MapAndBooking,
  Button,
  ButtonDisabled,
  RestaurantBanner,
  ViewMap,
  CardWrapper,
  Left,
  SpecialOfferWrapper,
  CloseBanner,
  CloseButton,
} from "./Modal.elements";

import {
  New,
  Flags,
  SpecialOffer,
  HotelRestaurantStar,
} from "./Results.elements";
import { IconSpecialOffer } from "./Results.icons";
import {
  IconCuisine,
  IconPin,
  IconStar,
  IconExternalLink,
} from "./Results.icons";

import auMerchantOverrides from "./auMerchantOverides";

function ModalMerchants({
  merchants,
  filterCallback,
  locale,
  country,
  isReady,
}) {
  const { results: copy } = useContext(Language);

  // function checkTakeoutFlag() {
  //   return props.isTakeoutAvailable ?? false;
  // }

  useEffect(() => {
    setTimeout(() => {
      setEqualHeights();
      if (isReady) {
        isReady(true);
      }
    }, 0);

    // let debFunc = debounce(() => {
    //   handleResize();
    // }, 50);

    // handleResize();

    // window.addEventListener("resize", debFunc);

    // return () => {
    //   if (debFunc) {
    //     window.removeEventListener("resize", debFunc);
    //   }
    // };
  }, []);

  // function handleResize() {
  //   updateShuffle();
  // }

  function setEqualHeights(childItemSelector) {
    const elements = Array.from(
      document.querySelectorAll("#modal .modal-card")
    );
    if (elements.length) {
      const heights = [];
      elements.forEach((el) => {
        heights.push(el.offsetHeight);
      });
      const maxHeight = Math.max(...heights);
      elements.forEach((el) => {
        el.querySelector("div").style.height = `${maxHeight}px`;
      });
    }
  }

  function getTranslation(key, translations) {
    const market = locale.replace("-", "_");
    if (translations[market] && translations[market][key]) {
      return translations[market][key];
    }
    // Fall back to "en" value...
    return translations["en"][key];
  }

  function getBusinessData(key, translations) {
    const market = locale.replace("-", "_");
    if (translations[key] && translations[key][market]) {
      return translations[key][market];
    }
    // Fall back to "en" value...
    return translations[key]['en'];
  }

  function translate(item, translations) {
    const market = locale.replace("-", "_");
    if (!item || !item.hasOwnProperty("translations")) {
      throw Error(`Translations object not in ${JSON.stringify(item)}`);
    }
    const f = item.translations[market] || item.translations["en"];
    return f.title;
  }
  const [currentModal, setCurrentModal] = useState(null);
  const handleOpenModal = (modalId) => setCurrentModal(modalId);
  const handleCloseModal = () => setCurrentModal(null);

  const handleMakeBooking = (website, name) => {
    window.tuiTrack.trackEvent('click', `makeBookingClick:${name}`);
    window.open(website, "_blank");
  };

  return (
    <>
      {merchants.map(
        ({
          id,
          name,
          address,
          cuisine,
          city,
          postcode,
          businessData,
          translations,
          googleMapsUrl,
          // takeoutAvailable,
          onlineOnly,
          isHalal,
        }) => {
          const {
            isNew,
            website,
            phone,
            openingSoon,
            resyVenueId,
            isInHotel,
            hasSpecialOffer,
          } = businessData;
          const hasWebsite = website && website.length;
          const hasPhone = phone && phone.length;
          const hasAuOverride =
            country === "AU" && auMerchantOverrides.includes(id);
          const hasHalal = isHalal === true;
          const hotelRestaurant = isInHotel === true;

          return (
            <div
              key={id}
              className="col-6@md modal-card"
              data-groups={`["${city.id}","${cuisine ? cuisine.id : "none"}"]`}
            >
              <Card>
                <CardBody>
                  <Flags id="flags" type="group">
                    {/* NEW Special Offer and modal */}
                    {hasSpecialOffer && (
                      <SpecialOffer
                      onClick={() => handleOpenModal(id)}
                      style={{ cursor: "pointer" }}
                      className="mr-2"
                      >
                        <IconSpecialOffer className="mr-2" />
                        {copy.specialOffer || "View Special Offer"}
                      </SpecialOffer>
                    )}
                    {isNew && <New>{copy.new}</New>}
                  </Flags>
                  <Left>
                    <Title>
                      {getTranslation("name", translations)}
                      {hotelRestaurant && (
                        <HotelRestaurantStar>
                          <IconStar />
                        </HotelRestaurantStar>
                      )}
                    </Title>

                    {!onlineOnly && (
                      <Address>
                        {getTranslation("address", translations)}
                        <br />
                        {translate(city)}
                        <br />
                        {getTranslation("postcode", translations)}
                      </Address>
                    )}

                    {onlineOnly && !address && (
                      <Address>{copy.onlineOnly}</Address>
                    )}

                    {onlineOnly && address && (
                      <Address>
                        {getTranslation("address", translations)}
                      </Address>
                    )}

                    {hasAuOverride && (
                      <div>Restaurant participation temporarily suspended</div>
                    )}
                    {!hasAuOverride && cuisine && (
                      <Detail>
                        <IconCuisine className="mr-2" />
                        {translate(cuisine)}
                      </Detail>
                    )}
                  </Left>
                  <MapAndBooking>
                    {!hasAuOverride && !onlineOnly && googleMapsUrl && (
                      <MapLink>
                        <ViewMap
                          rel="noopener noreferrer"
                          target="_blank"
                          href={googleMapsUrl}
                        >
                          {copy.viewmap}
                        </ViewMap>
                        <IconPin />
                      </MapLink>
                    )}

                    {/* 
                  {takeoutFlag && takeoutAvailable && (
                    <Detail>
                    <IconTakeout />
                    {copy[takeoutAvailable]}
                    </Detail>
                  )} */}
                    {hasHalal && <Detail>{copy.halal}</Detail>}
                    {hasAuOverride && <div />}
                    {!hasAuOverride && (
                      <div style={{ width: "100%" }}>
                        {resyVenueId ? (
                          <div id={id}></div>
                        ) : (
                          <>
                            {hasWebsite && (
                              <>
                                {openingSoon ? (
                                  <ButtonDisabled>
                                    {website.split("/")[2].replace("www.", "")}
                                  </ButtonDisabled>
                                ) : (
                                  <Button
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    onClick={() => handleMakeBooking(website, getTranslation("name", translations))}
                                  >
                                    {copy.makebooking.replace(":", "")}
                                    <IconExternalLink />
                                  </Button>
                                )}
                              </>
                            )}
                            {!hasWebsite && hasPhone && (
                              <>
                                {openingSoon ? (
                                  <ButtonDisabled>
                                    {website.split("/")[2].replace("www.", "")}
                                  </ButtonDisabled>
                                ) : (
                                  <Button
                                    rel="noopener noreferrer"
                                    href={`tel:${phone}`}
                                  >
                                    {phone}
                                  </Button>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </MapAndBooking>
                </CardBody>
              </Card>
              {/* Modal Component Outside of Card */}
              {currentModal && (
                <ModalContainer
                  id="modal"
                  tabIndex="0"
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                  type="specialoffer"
                >
                  <RestaurantBanner>
                    {/* Display the business name or special offer title */}
                    {getTranslation("name", translations)}
                    <Cross onClick={handleCloseModal} />
                  </RestaurantBanner>
                  <SpecialOfferWrapper>
                    {/* Special offer details */}
                    <span dangerouslySetInnerHTML={{ __html: getBusinessData("specialOfferDetails", businessData) }} />
                  </SpecialOfferWrapper>
                  <CloseBanner type="specialoffer">
                    <CloseButton
                      role="button"
                      tabIndex="0"
                      onClick={handleCloseModal}
                    >
                      {copy.close}
                    </CloseButton>
                  </CloseBanner>
                </ModalContainer>
              )}
            </div>
          );
        }
      )}
    </>
  );
}

export default function Modal({
  locale,
  country,
  merchants,
  merchant,
  closeModal,
}) {
  const { results: copy } = useContext(Language);
  const [modalVisible, setModalVisible] = useState(false);
  const isReady = (readyState) => {
    setModalVisible(readyState);
  };

  function translateMerchantName(item) {
    const market = locale.replace("-", "_");
    if (!item || !item.hasOwnProperty("translations")) {
      throw Error(`Translations object not in ${JSON.stringify(item)}`);
    }
    const f = item.translations[market] || item.translations["en"];
    return f.name;
  }

  return (
    <ModalContainer
      id="modal"
      tabindex="0"
      style={{ visibility: modalVisible ? "" : "hidden" }}
    >
      <RestaurantBanner id="rest-ban">
        {merchants.length} {translateMerchantName(merchant)} {copy.locations}
        <Cross
          onClick={closeModal}
          // onKeyUp={(e) => {
          //   console.log(e.keyCode);
          //   if (e.keyCode === 27 || e.keyCode === 13 || e.keyCode === 32) {
          //     closeModal();
          //   }
          // }}
        >
          <span className="visuallyHidden">{copy.close}</span>
        </Cross>
      </RestaurantBanner>
      <CardWrapper>
        <div className="row">
          <ModalMerchants
            merchants={merchants}
            isReady={isReady}
            locale={locale}
            country={country}
          />
        </div>
      </CardWrapper>
      {/* <CloseBanner>
        <CloseButton role="button" tabindex="0" onClick={closeModal}>
          {copy.close}
        </CloseButton>
      </CloseBanner> */}
    </ModalContainer>
  );
}
